import Loadable from 'react-loadable';
import { Loading } from '../../common/navigation';

const ParentDashboard = Loadable({
  loader: () => import('./components/parent-dashboard'),
  loading: Loading,
});

export const routes = [
  {
    path: '/parent-dashboard',
    exact: true,
    name: 'Parent Dashboard',
    component: ParentDashboard,
  },
];
export * from './components';
